const getLinearGradient = (colorA: string, colorB: string) => {
  return `linear-gradient(to bottom, ${colorA}, ${colorB});`;
};

export { getLinearGradient };
